/* dashboard-rediseno (15-oct-2026): EL CAMPO DE YOUTUBE DEL PANEL, CON "IMPORT" ADENTRO.

   ARCHIVO EN ASCII A PROPOSITO (regla de la casa para los `.js` nuevos).

   Lo usan la tarjeta para agregar material y la zona grande (sin documentos). El campo lleva
   el icono de video (salvo en el telefono, para que quepa el texto), "Import" ADENTRO (fondo
   #241710, texto #F7A06A, ancho minimo 76 px para que no cambie al mostrar el giro) y 16 px de
   letra en el telefono. Debajo, mientras busca, "Getting transcript..." y, si falla, el error
   en rojo de hasta dos renglones (F4). El flujo es el de hoy: lo decide el Panel.

   El tope de documentos: con el campo apagado por tope, el toque en "Import" se oye en un
   envoltorio (el boton apagado no recibe eventos) y el Panel avisa, como hoy (REMATE-E). */
import React from 'react';
import { Loader2, Video } from 'lucide-react';
import { AreaDe44 } from './anatomia';

export default function CampoDeYoutube({
  t, valor, alCambiar, alImportar, cargando, campoApagado, botonApagado, error, conIcono = true,
  alTocarConTope, tituloDelBoton, alto = 'tarjeta',
}) {
  const altoCampo = alto === 'zona' ? 'h-12' : 'h-[52px] md:h-11';
  return (
    <div className="min-w-0 flex-1">
      <div className="relative flex-1 min-w-0" data-testid="youtube-import-row">
        {conIcono ? (
          <Video className="hidden md:block w-4 h-4 text-[#F7A06A] absolute left-3.5 top-1/2 -translate-y-1/2 pointer-events-none" aria-hidden="true" />
        ) : null}
        <input
          type="url"
          value={valor}
          onChange={(e) => alCambiar(e.target.value)}
          onKeyDown={(e) => { if (e.key === 'Enter' && !cargando) alImportar(); }}
          placeholder={t('dashboard:panel.pega_link')}
          aria-label={t('dashboard:panel.pega_link')}
          disabled={campoApagado}
          className={`w-full ${altoCampo} rounded-[14px] bg-[#0E0E0E] border border-[#262626] text-[#F4F4F3] text-[16px] md:text-[14px] pl-3.5 ${conIcono ? 'md:pl-10' : ''} pr-[92px] outline-none focus:border-[#F27A2E] text-ellipsis overflow-hidden whitespace-nowrap placeholder:text-[#6A6A6A] disabled:opacity-45`}
          data-testid="youtube-url-input"
        />
        {/* REMATE-E: el boton apagado no recibe eventos; el toque con el tope lleno lo oye este
            envoltorio, que va pegado a la derecha DENTRO del campo y no encoge.
            Segunda vuelta (D11): el envoltorio lleva el area de 44 de "Import" (el dibujo sigue de
            76 x 32). Un toque en el area, fuera del boton, hace lo que haria el boton: importa si
            esta encendido y, apagado, lo de siempre (el aviso del tope). */}
        <span className="absolute right-1.5 top-1/2 -translate-y-1/2 shrink-0"
          onClick={() => {
            if (botonApagado) { if (alTocarConTope) alTocarConTope(); return; }
            if (!cargando) alImportar();
          }}
          data-testid="youtube-import-guard">
          <AreaDe44 />
          <button
            type="button"
            onClick={(e) => { e.stopPropagation(); alImportar(); }}
            title={tituloDelBoton}
            disabled={botonApagado}
            className="relative h-8 shrink-0 min-w-[76px] px-3 rounded-[10px] bg-[#241710] text-[#F7A06A] text-[13px] font-semibold inline-flex items-center justify-center gap-1.5 active:bg-[#3A2414] active:scale-[0.98] active:duration-0 disabled:opacity-45 disabled:pointer-events-none"
            data-testid="youtube-import-btn"
          >
            {cargando ? <Loader2 className="w-4 h-4 animate-spin" aria-hidden="true" /> : t('dashboard:youtube.import_button')}
          </button>
        </span>
      </div>
      {cargando ? (
        <p className="mt-1.5 text-[13px] leading-[18px] text-[#9A9A9A]" data-testid="youtube-cargando">{t('dashboard:youtube.loading')}</p>
      ) : error ? (
        <p role="alert" className="mt-1.5 text-[13px] leading-[18px] text-[#F87171] line-clamp-2" data-testid="youtube-error">{error}</p>
      ) : null}
    </div>
  );
}
